import React, { useState, MouseEvent } from 'react';
import classNames from 'classnames';
import { useOutsideClick } from '@hooks/useOutsideClick';
import { Dropdown } from '@components/Dropdown';

export const useDropdown = (content: React.ReactNode) => {
  const dropdownContainerRef = React.useRef<HTMLDivElement>(null);
  const dropdownRef = React.useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    setIsOpen(!isOpen);
  };

  useOutsideClick(dropdownContainerRef, () => {
    setIsOpen(false);
  });

  return {
    isOpen,
    onOpen: handleClick,
    DropdownWrapper: ({ children }: { children: React.ReactNode }) => (
      <div
        ref={dropdownContainerRef}
        className={classNames('c-dropdown-button-container')}
        style={{
          position: 'relative',
        }}
      >
        {children}
        {isOpen && <Dropdown ref={dropdownRef}>{content}</Dropdown>}
      </div>
    ),
  };
};
